import { Col, Container, Row } from "react-bootstrap"
import { navigateTo } from "../../redux/router/routerActions"
import { useAppDispatch } from "../../redux/store"
import QuickForm from "../../Components/Forms/QuickForm/QuickForm"
import { convertActiveQueryToUrl } from "../../Helpers/Query/queryHelpers";
import useActiveQueryHook from "../../Hooks/UseActiveQuery/useActiveQueryHook";
import { useGetKeyValuesQuery } from "../../services/bClientApi"
import MongoPagination from "../../Components/Pagination/MongoPagination"
import { KeyValueType } from "../../Types/keyValueType"
import { Button } from "react-bootstrap"
import KeyValueEntry from "../../Components/KeyValue/KeyValueEntry/KeyValueEntry"

export default function KeyValuesPage() {

    const dispatch = useAppDispatch()

    const { activeQuery } = useActiveQueryHook({
        query: {},
        limit: 10,
    })

    const {
        data,
        error,
        isLoading,
    } = useGetKeyValuesQuery({
        keyValuesQuery: activeQuery.query,
        pagination: {
            page: activeQuery.page,
            limit: activeQuery.limit,
        }
    })
    const keyValuesList = data?.docs || []

    const loadPage = (pageParams: { query: any, page: number, limit: number }) => {
        const destination = `/key-values?${convertActiveQueryToUrl(pageParams)}`
        dispatch(navigateTo(destination))
    }

    return (
        <Container>
            <Row>
                <Col>
                    <div className="d-flex justify-content-between align-items-center">
                        <h1>Key Values</h1>
                        <Button 
                            variant="primary" 
                            onClick={() => dispatch(navigateTo('/add-key-value'))}
                        >
                            Add New Key Value
                        </Button>
                    </div>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}

                    <QuickForm
                        layout={{ xs: 2 }}
                        initialData={{
                            createdAtStart: activeQuery.query.createdAtStart,
                            createdAtEnd: activeQuery.query.createdAtEnd,
                            updatedAtStart: activeQuery.query.updatedAtStart,
                            updatedAtEnd: activeQuery.query.updatedAtEnd,
                            expiresAtStart: activeQuery.query.expiresAtStart,
                            expiresAtEnd: activeQuery.query.expiresAtEnd,
                            namespace: activeQuery.query.namespace,
                            key: activeQuery.query.key,
                            // hasExpiration: activeQuery.query.hasExpiration,
                        }}
                        fields={[
                            {
                                fieldName: 'createdAtStart',
                                fieldType: 'date',
                                fieldLabel: 'Created Start',
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                            {
                                fieldName: 'createdAtEnd',
                                fieldType: 'date',
                                fieldLabel: 'Created End',
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                            {
                                fieldName: 'updatedAtStart',
                                fieldType: 'date',
                                fieldLabel: 'Updated Start',
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                            {
                                fieldName: 'updatedAtEnd',
                                fieldType: 'date',
                                fieldLabel: 'Updated End',
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                            {
                                fieldName: 'expiresAtStart',
                                fieldType: 'date',
                                fieldLabel: 'Expires Start',
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                            {
                                fieldName: 'expiresAtEnd',
                                fieldType: 'date',
                                fieldLabel: 'Expires End',
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                            {
                                fieldName: 'namespace',
                                fieldType: 'text',
                                fieldLabel: 'Namespace',
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                            {
                                fieldName: 'key',
                                fieldType: 'text',
                                fieldLabel: 'Key',
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                            // {
                            //     fieldName: 'hasExpiration',
                            //     fieldType: 'select',
                            //     fieldLabel: 'Has Expiration',
                            //     options: [
                            //         { value: '', text: 'All' },
                            //         { value: 'true', text: 'Has Expiration' },
                            //         { value: 'false', text: 'No Expiration' }
                            //     ],
                            //     layout: {
                            //         xs: 12,
                            //         md: 6,
                            //     }
                            // }
                        ]}
                        disabled={isLoading}
                        onSubmit={(values: any) => {
                            loadPage({
                                query: values,
                                page: 1,
                                limit: activeQuery.limit
                            })
                        }}
                    />

                    <div className="key-values-list-container">
                        {keyValuesList && keyValuesList.length > 0 ? (
                            <div>
                                {keyValuesList.map((keyValue: KeyValueType, idx: number) => (
                                    <KeyValueEntry
                                        key={`${keyValue._id}-${idx}`}
                                        keyValueData={keyValue}
                                    />
                                ))}
                            </div>
                        ) : (
                            <div className="text-center p-4">
                                <h5>No key values found</h5>
                                <p className="text-muted">Try adjusting your search criteria or add a new key value.</p>
                                <Button 
                                    variant="primary" 
                                    onClick={() => dispatch(navigateTo('/add-key-value'))}
                                >
                                    Add New Key Value
                                </Button>
                            </div>
                        )}

                        {data && (
                            <MongoPagination
                                paginationData={data}
                                currentPage={activeQuery.page}
                                onPageChange={(page: number) => {
                                    loadPage({
                                        query: activeQuery.query,
                                        page,
                                        limit: activeQuery.limit
                                    })
                                }}
                            />
                        )}
                    </div>
                </Col>
            </Row>
        </Container>
    )
}